import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CHEVRON_DOWN, CLOSE, PROFILE } from "../../../assets";

import ButtonV2 from "../buttonV2";
import useDropdown from "../../../utils-func/functions/usedropdown";

import { toast } from "react-hot-toast";

import {
  addUser,
  getJudicialDivisionsAdmin,
} from "../../../Services/admin.service";
import SuccessModal from "../successModal";
import { useQuery } from "react-query";
import { useFetcher } from "react-router-dom";

function AddUserModal({
  open,
  close,
  refetch,
}: {
  open: boolean;
  close: () => void;
  refetch: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [selectedJudiciary, setSelectedJudiciary] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedUserType, setSelectedUserType] = useState<string>("");
  const { dropdownRef, dropdowns, setDropdowns, closeDropDown } = useDropdown();
  const [success, setSuccess] = useState(false);
  const { data: judicialDivision } = useQuery(
    ["division", 0],
    () => getJudicialDivisionsAdmin(0),
    {
      refetchOnWindowFocus: false,
      enabled: open,
    },
  );
  const [erros, setErros] = useState<any>(null);
  const [formInput, setFormInput] = useState({
    name: "",

    email: "",
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const handleAddUser = async () => {
    setErros(null);
    setLoading(true);

    if (selectedUserType === "court_staff" && !selectedJudiciary) {
      setErros({ judicial_division_id: ["Judicial division is required"] });
      setLoading(false);
      return;
    }

    const payload = {
      type: selectedUserType,
      name: formInput.name,
      email: formInput.email,
      judicial_division_id: selectedJudiciary?.id,
    };

    try {
      const response = await addUser(payload);
      if (response) {
        setSuccess(true);
        close();
        setFormInput({
          email: "",
          name: "",
        });
        setSelectedUserType("");
      }
    } catch (error: any) {
      if (error?.response?.status === 422) {
        toast.error("Oops!, something ismissing");
        setErros(error?.response?.data?.errors);
      } else {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (selectedUserType === "court_staff") {
  //     setDropdowns({ ...dropdowns, judicial: true });
  //   }
  // }, [selectedUserType]);
  return (
    <>
      <div
        className={`w-full h-full fixed ${
          open ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[600px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-lightGold rounded-xl p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                Add New User
              </h2>
              <button
                onClick={close}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>

            <div className="w-full flex items-center justify-center mt-5">
              <img src={PROFILE} className="w-[64px] h-[64px]" alt="" />
            </div>
            <form
              action=""
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col gap-y-4 p-5"
            >
              <div className="flex lg:flex-row flex-col gap-y-3 items-start w-full gap-x-4">
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    User's Name
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <input
                      type="text"
                      name="name"
                      value={formInput.name}
                      onChange={handleInputChange}
                      placeholder="User name"
                      className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                    />
                  </div>
                  <span className="text-red-500 text-xs">
                    {erros?.name && erros?.name[0]}
                  </span>
                </div>
                <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    User Type
                  </span>
                  <div
                    onClick={() =>
                      setDropdowns({ ...dropdowns, userType: true })
                    }
                    className="flex items-center justify-between  gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      placeholder="User type"
                      value={selectedUserType.replace(/_/g, " ")}
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />
                    {/* <span className="text-sm font-medium text-customDark">
                                                          {selectedState?.name || "Enter state"}
                                                        </span> */}
                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {dropdowns.userType && (
                    <div
                      ref={dropdownRef.userType}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {["individual", "admin", "company", "court staff"].map(
                        (item) => (
                          <span
                            onClick={() => {
                              setSelectedUserType(
                                item === "court staff" ? "court_staff" : item,
                              );
                              closeDropDown("userType");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item}
                          </span>
                        ),
                      )}
                    </div>
                  )}
                </div>
                <span className="text-red-500 text-xs">
                  {erros?.type && erros?.type[0]}
                </span>
              </div>

              <div className="flex lg:flex-row flex-col gap-y-3 items-start w-full gap-x-4">
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Email
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <input
                      type="text"
                      placeholder="Email"
                      name="email"
                      value={formInput.email}
                      onChange={handleInputChange}
                      className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                    />
                  </div>
                  {formInput.email && !emailRegex.test(formInput.email) && (
                    <span className="text-xs font-normal text-red-500">
                      Kindly use a valid email address
                    </span>
                  )}
                  <span className="text-red-500 text-xs">
                    {erros?.email && erros?.email[0]}
                  </span>
                </div>
              </div>
              {selectedUserType === "court_staff" && (
                <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Judicial Division <span className="text-red-500">*</span>
                  </span>

                  <div
                    onClick={() => {
                      setDropdowns({ ...dropdowns, judicial: true });
                    }}
                    className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      value={selectedJudiciary?.name}
                      placeholder="Enter judicial division"
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />
                    {/* <span className="text-sm font-medium text-customDark">
                                                  {selectedLga?.name || "Enter local govt area (LGA)"}
                                                </span> */}
                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {judicialDivision?.data?.length > 0 && dropdowns.judicial && (
                    <div
                      ref={dropdownRef.judicial}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {judicialDivision?.data?.map(
                        (item: {
                          id: number;
                          name: string;

                          created_at: string;
                          updated_at: string;
                        }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedJudiciary(item);
                              closeDropDown("judicial");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        ),
                      )}
                    </div>
                  )}
                  <span className="text-red-500 text-xs">
                    {erros?.judicial_division_id &&
                      erros?.judicial_division_id[0]}
                  </span>
                </div>
              )}
            </form>

            <div className="flex items-end justify-end gap-x-3 p-8">
              <ButtonV2
                title={"Add user"}
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                loading={loading}
                loaderColor="#ffffff"
                handleClick={handleAddUser}
              />
            </div>
          </motion.div>
        )}
        <SuccessModal
          open={success}
          close={() => setSuccess(false)}
          action={() => {
            setSuccess(false);
            refetch();
          }}
          message={"User Successfully Added"}
          message2={"You have successfully added a user"}
        />
      </div>
    </>
  );
}

export default AddUserModal;
